import { RefObject, useEffect } from 'react';

function useCssProp(
  ref: RefObject<HTMLElement>,
  name: string,
  value?: number | string
) {
  useEffect(() => {
    if (!ref.current || value === undefined) return;
    ref.current.style.setProperty(
      `--${name}`,
      typeof value === 'number' ? `${value}px` : value
    );
  }, [name, ref, value]);
}

export default useCssProp;
